"use strict";
exports.__esModule = true;
exports.CustomerExperienceCancelEventTypes = exports.TaskPhase = exports.ApiVersion = void 0;
var ApiVersion;
(function (ApiVersion) {
    ApiVersion[ApiVersion["V1"] = 1] = "V1";
    ApiVersion[ApiVersion["V2"] = 2] = "V2";
})(ApiVersion = exports.ApiVersion || (exports.ApiVersion = {}));
var TaskPhase;
(function (TaskPhase) {
    TaskPhase["CREATED"] = "created";
    TaskPhase["SCHEDULING"] = "scheduling";
    TaskPhase["SCHEDULED"] = "scheduled";
    TaskPhase["DONE"] = "done";
    TaskPhase["RATING"] = "rating";
})(TaskPhase = exports.TaskPhase || (exports.TaskPhase = {}));
var CustomerExperienceCancelEventTypes;
(function (CustomerExperienceCancelEventTypes) {
    CustomerExperienceCancelEventTypes[CustomerExperienceCancelEventTypes["DriverAssigned"] = 0] = "DriverAssigned";
    CustomerExperienceCancelEventTypes[CustomerExperienceCancelEventTypes["TaskStarted"] = 1] = "TaskStarted";
})(CustomerExperienceCancelEventTypes = exports.CustomerExperienceCancelEventTypes || (exports.CustomerExperienceCancelEventTypes = {}));
//# sourceMappingURL=customer_experience.js.map